import VilgramFileDto from "../dto/VilagramFileDto";

/// BOOKMARK
export const saveBookmark = (vila: VilgramFileDto) => {
    let data = JSON.parse(localStorage.getItem('vilagram-saved') ?? '[]') as VilgramFileDto[]
    if (data.findIndex((val, inx, ar) => {
        return val.id === vila.id
    }) === -1) {
        data.unshift(vila)
        localStorage.setItem('vilagram-saved', JSON.stringify(data))
    }
}

export const removeBookmark = (id: number) => {
    let data = (JSON.parse(localStorage.getItem('vilagram-saved') ?? '[]') as VilgramFileDto[]).filter((val, inx, arr) => {
        return val.id !== id
    })
    localStorage.setItem('vilagram-saved', JSON.stringify(data))
}

export const loadBookmark = (): VilgramFileDto[] => JSON.parse(localStorage.getItem('vilagram-saved') ?? '[]') as VilgramFileDto[]

export const isBookmarked = (id: number) => (JSON.parse(localStorage.getItem('vilagram-saved') ?? '[]') as VilgramFileDto[]).findIndex((val, inx, ar) => {
    return val.id === id
}) !== -1


/// SEEN

export const saveSeen = (vila: VilgramFileDto) => {
    let data = JSON.parse(localStorage.getItem('vilagram-seen') ?? '[]') as VilgramFileDto[]
    if (data.findIndex((val, inx, ar) => {
        return val.id === vila.id
    }) === -1) {
        data.unshift(vila)
        localStorage.setItem('vilagram-seen', JSON.stringify(data))
    }
}

export const loadSeen = (): VilgramFileDto[] => JSON.parse(localStorage.getItem('vilagram-seen') ?? '[]') as VilgramFileDto[]
